import { Identity } from './User'

export enum DocumentFileType {
  ZOCKS = 'zocks',
  INTEGRATION = 'integration',
}

export interface DocumentTypeProcessingStatus {
  startedAt: string | null
  finishedAt: string | null
  typeId: string | null
  label: string | null
}

export interface DocumentSummaryProcessingStatus {
  startedAt: string | null
  finishedAt: string | null
}

interface BaseDocumentFile {
  size: number
  name: string
  contentType: string
  hash?: string
}

export interface ZocksDocumentFile extends BaseDocumentFile {
  type: DocumentFileType.ZOCKS
  fileId: string
}

export interface IntegrationDocumentFile extends BaseDocumentFile {
  type: DocumentFileType.INTEGRATION
  fileId: string
  connector: string
}

export type DocumentFile = ZocksDocumentFile | IntegrationDocumentFile

export interface DocumentRecord {
  id: string
  documentBatchId: string | null
  name: string
  contactId: string
  typeProcessing: DocumentTypeProcessingStatus
  summaryProcessing: DocumentSummaryProcessingStatus
  files: DocumentFile[]
  createdBy: Identity
  updatedBy: Identity
  createdAt: string
  updatedAt: string
}

export interface DocumentCreate {
  name: string
  contactId: string
  files: DocumentFile[]
}

export interface DocumentUpdate {
  typeProcessing?: Partial<DocumentTypeProcessingStatus>
  summaryProcessing?: Partial<DocumentSummaryProcessingStatus>
}

export enum DocumentProcessingStatusType {
  SAVED = 'saved',
  READY = 'ready',
  LOADING = 'loading',
  PROCESSING = 'processing',
}
